import React from 'react';
import ESignatureEdit from '../contract/ESignatureEdit';

const SourcingESignatureEdit = () => {
  return <ESignatureEdit module="rfp" />;
};

export default SourcingESignatureEdit;
